export default __webpack_public_path__ + "img/618c05f29208601dbbb3039fdbc5d6de.png";